import { createSlice } from '@reduxjs/toolkit'

// Autopay / recurring-payments state (Stripe-only in Phase 1): the saved-card vault, the
// hosted card-setup URL, a family's subscriptions, and the staff needs-attention list.
// Reducers are saga triggers; the saga does the API work and merges results via sliceOp.
export const initialState = {
  isLoading: false,
  operationType: undefined,
  checkoutSessionUrl: undefined,   // Stripe hosted card-setup page (autopay at checkout)
  paymentMethods: [],
  paymentMethodsAccountId: undefined, // whose saved cards have loaded — [] alone can't tell "none" from "not yet"
  subscriptions: [],
  subscriptionsAccountId: undefined, // whose subscriptions have loaded — [] alone can't tell "none" from "not yet"
  needsAttention: [],
  bookingAutopayMap: {},     // { bookingId: { status, autopayEnrolled, needsAttention } } for list badges
  enrollResult: undefined,   // { subscription, firstCharge: { attempted, succeeded, failed } }
  replaceCardResult: undefined, // { updated[], untouched[], charged, failed } — what the new card actually changed
  error: undefined,
}

export const paymentSlice = createSlice({
  name: 'payment',
  initialState: { ...initialState },
  reducers: {
    createCheckoutSession: (state, _action) => { state.isLoading = true },
    getPaymentMethods: (state, _action) => { state.isLoading = true },
    enrollSubscription: (state, _action) => { state.isLoading = true },
    getAccountSubscriptions: (state, _action) => { state.isLoading = true },
    getNeedsAttention: (state, _action) => { state.isLoading = true },
    getBookingAutopayMap: (state, _action) => { state.isLoading = true },
    retryAutopay: (state, _action) => { state.isLoading = true },
    sendCardReminder: (state, _action) => { state.isLoading = true },
    replaceCard: (state, _action) => { state.isLoading = true },
    confirmIncrease: (state, _action) => { state.isLoading = true },
    sliceOperation: (state, action) => {
      if (action.payload) Object.assign(state, action.payload);
    },
    paymentSagaFailed: (state, action) => {
      state.isLoading = false;
      state.operationType = undefined;
      if (action.payload) Object.assign(state, action.payload);
    },
  },
})

export const {
  createCheckoutSession,
  getPaymentMethods,
  enrollSubscription,
  getAccountSubscriptions,
  getNeedsAttention,
  getBookingAutopayMap,
  retryAutopay,
  sendCardReminder,
  replaceCard,
  confirmIncrease,
  sliceOperation,
  paymentSagaFailed,
} = paymentSlice.actions

export default paymentSlice.reducer
